export const tr = {
    collapse: 'Gizle',
    expand: 'Genişlet'
};
